<template>
    <div>
       <div class="spark-screen container">
            <div class="row">
                <div class="col-md-3 spark-settings-tabs">
                    <aside>
                        <div>
                            <h3 class="nav-heading">
                                Custom Fields
                            </h3>
                            <div class="text-right">
                                <button @click.prevent.stop="openFieldModal()"
                                        class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                                    add
                                </button>
                            </div>
                        </div>
                        <ul class="nav flex-column mb-4">
                            <li class="nav-item" v-for="cf in custom_fields">
                                <a class="nav-link" :href="'#cf-' + cf.id" :class="selected_custom_field.id == cf.id ? 'active' : ''"
                                    :aria-controls="cf.name" role="tab" data-toggle="tab" @click.prevent="selected_custom_field = cf">
                                    <div :class="{underline:selected_custom_field.id == cf.id}">
                                        {{cf.name}}
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </aside>
                </div>

                <div class="col-md-9" id="">
                    <h5 v-if="custom_fields.length == 0">Register your first custom Field</h5>
                    <div v-if="custom_fields.length > 0">
                        <div></div>
                        <div>
                            <div class="card card-default">
                                <div class="card-header text-lg flex justify-between">
                                    <div class="w-1/4">
                                        Name
                                    </div>
                                    <div class="w-1/4">
                                        Type
                                    </div>
                                    <div class="w-1/4">
                                        Enabled
                                    </div>
                                    <div class="w-1/4">
                                        Actions
                                    </div>
                                </div>
                                <div class="card-body text-lg flex justify-between">
                                    <div class="w-1/4">
                                        {{ selected_custom_field.name }}
                                    </div>
                                    <div class="w-1/4">
                                        {{ getTypeName(selected_custom_field.type) }}
                                    </div>
                                    <div class="w-1/4">
                                        <input type="checkbox" v-model="selected_custom_field.enabled" disabled>
                                    </div>
                                    <div class="w-1/4">
                                        <button @click.prevent="openFieldModal(selected_custom_field)"
                                                class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                                        </button>
                                        <button @click.stop="deleteField(selected_custom_field)"
                                                class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selected_custom_field.type == 3">
                            <div class="text-right">
                                <button @click.prevent.stop="openFieldOptionModal(null, selected_custom_field.id)"
                                        class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white  p-1 rounded-full text-base text-followup-nav">
                                    Add Option
                                </button>
                            </div>
                            <div class="bg-white shadow-md rounded mb-6 mt-2">
                                <table class="text-left w-full border-collapse">
                                    <thead>
                                    <tr>
                                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center">
                                            Name
                                        </th>
                                        <th class="py-2 pl-4 bg-grey-lightest font-boldco uppercase text-xs text-grey-darkest border-b border-grey-light text-center">
                                            Description
                                        </th>
                                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center">
                                            Load Order
                                        </th>
                                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center">
                                            Enabled
                                        </th>
                                        <th class="py-2 pl-4 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr @click="openFieldOptionModal(option)" class="hover:bg-grey-lighter cursor-pointer" v-for="option in selected_custom_field.options" :key="option.id">
                                        <td class="pl-4 py-2 border-b border-grey-light text-xs text-center">
                                            {{ option.name }}
                                        </td>
                                        <td class="pl-4 py-2 border-b border-grey-light text-xs text-center">
                                            {{ option.description }}
                                        </td>
                                        <td class="pl-4 py-2 border-b border-grey-light text-xs text-center">
                                            {{ option.load_order }}
                                        </td>
                                        <td class="pl-4 py-2 border-b border-grey-light text-xs text-center">
                                            <input type="checkbox" v-model="option.enabled" disabled>
                                        </td>
                                        <td class="px-4 py-2 border-b border-grey-light">
                                            <button @click.stop="openFieldOptionModal(option)"
                                                    class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                                            </button>
                                            <button @click.stop="deleteOption(option)"
                                                    class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">delete
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <companies-custom-field-modal ref="CompanyCustomFieldModal" :team="team" v-on:saved="fetchData"></companies-custom-field-modal>
        <companies-custom-field-option-modal ref="CompanyCustomFieldOptionModal" v-on:saved="fetchData"></companies-custom-field-option-modal>
        <div class="spark-screen container mt-2">
            <div class="row">
                <div class="col-md-3 spark-settings-tabs">
                    <aside>
                        <div>
                            <h3 class="nav-heading">
                                Company Status
                            </h3>
                            <div v-if="companyStatuses.length == 0" class="text-right">
                                <button @click.prevent.stop="openStatusOptionModal()"
                                        class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                                    add
                                </button>
                            </div>
                        </div>
                    </aside>
                </div>

                <div class="col-md-9" id="">
                    <h5 v-if="companyStatuses.length == 0">Register your first company status</h5>
                    <div v-if="companyStatuses.length > 0">
                        <div class="text-right">
                            <button @click.prevent.stop="openStatusOptionModal()"
                                    class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white  p-1 rounded-full text-base text-followup-nav">
                                Add Status
                            </button>
                        </div>
                        <div class="bg-white shadow-md rounded mb-6 mt-2">
                            <table class="text-left w-full border-collapse">
                                <thead>
                                <tr>
                                    <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center">
                                        Status
                                    </th>
                                    <th class="py-2 pl-4 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr @click="openStatusOptionModal(status)" class="hover:bg-grey-lighter cursor-pointer" v-for="status in companyStatuses" :key="status.id">
                                    <td class="pl-4 py-2 border-b border-grey-light text-xs text-center">
                                        {{ status.name }}
                                    </td>
                                    <td class="px-4 py-2 border-b border-grey-light">
                                        <button @click.stop="openStatusOptionModal(status)"
                                                class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                                        </button>
                                        <button @click.stop="deleteStatusOption(status)"
                                                class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">delete
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <company-status-option-modal ref="CompanyStatusOptionModal" v-on:saved="fetchCompanyStatus"></company-status-option-modal>
    </div>
</template>

<script>
export default {
    name: 'companies-custom-fields',
    props: ['team'],
    data() {
        return {
            custom_fields: [],
            selected_custom_field: null,
            companyStatuses: []
        };
    },
    created(){
        this.fetchData();
        this.fetchCompanyStatus();
    },

    methods: {
        fetchData(){
            axios.get(route('api.company-custom-field.index')).then(
                (data) => {
                    this.custom_fields = data.data.data;
                    this.selected_custom_field = data.data.data[0];
                }
            )
        },
        fetchCompanyStatus() {
            axios.get(route('api.company-status.index')).then(
                (data) => {
                    this.companyStatuses = data.data;
                }
            )
        },
        openFieldModal(custom_field = null) {
            this.$refs.CompanyCustomFieldModal.open(custom_field);
        },

        openFieldOptionModal(option = null, custom_field_id = null) {
            this.$refs.CompanyCustomFieldOptionModal.open(option, custom_field_id);
        },

        openStatusOptionModal(companyStatus = null) {
            this.$refs.CompanyStatusOptionModal.open(companyStatus);
        },
      deleteField(field)
        {
          axios.post(route('api.company-custom-field.check-automations', field.id)).then((response) => {
          if(response.data.linked_to_automations){
            this.deleteAfterValidation("This custom field is currently utilized in automations. Are you sure you wish to proceed with its deletion? Please note that once deleted, this field cannot be recovered!", field);
          }else{
            this.deleteAfterValidation("Once deleted, you will not be able to recover this field!", field);
          }
        }).catch(error => {
          Swal.fire({
            title: "ERROR",
            text: "Something went wrong please try again later",
            confirmButtonColor: 'red',
            dangerMode: true,
          });
        });
        return false;

      },
      deleteAfterValidation(message, field) {
        let self = this;
        Swal.fire({
          title: "Are you sure?",
          text: message,
          icon: "warning",
          buttons: true,
          dangerMode: true,
          showCancelButton: true,
          confirmButtonColor: '#01B1AF',
          confirmButtonText: 'I\'m sure!',
          closeOnConfirm: true,
          closeOnCancel: true,
        }).then((result) => {
          if (result.value) {
            axios.delete(route('api.company-custom-field.destroy', field.id)).then(() => {
              self.fetchData();
            }).catch(error => {
              if(error.response.data.message.includes('SQLSTATE[23000]')){
                Swal.fire({
                  title: "ERROR",
                  text: "That are companies that already contains this field",
                  confirmButtonColor: 'red',
                  dangerMode: true,
                });
              }
            });
          }
        });
      },

        deleteOption(option)
        {
            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this option!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then((result) => {
                if (result.value) {
                    axios.delete(route('api.company-custom-field-option.destroy', option.id)).then(() => {
                        self.fetchData();
                    });
                }
            });
        },

        deleteStatusOption(status) {

            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this status!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then((result) => {
                if (result.value) {
                    axios.delete(route('api.company-status.destroy', status.id)).then(() => {
                        self.fetchCompanyStatus();
                    });
                }
            });
        },

        getTypeName(type){
            switch (type) {
                case 1:
                    return 'User';
                case 2:
                    return 'Text';
                case 3:
                    return 'Dropdown';
            }
        }
    },
}
</script>
